/** Bonnie's authored dimensions in metres. */
export const BONNIE_WIDTH_M = 0.5;
export const BONNIE_DEPTH_M = 0.3;
export const BONNIE_HEIGHT_M = 1.75;
